import request from '../../axios';

const getCheckContactLimit = async (guid: string) => {
  const {data}: {data: IGetCheckContact} = await request.get(
    `/api/v2/store/check-contact-limit?requirement_guid=${guid}`,
  );
  return data;
};

export default getCheckContactLimit;
